var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxIconThreeDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 2.99999C10.6667 3.92047 9.92047 4.66666 8.99999 4.66666C8.07952 4.66666 7.33333 3.92047 7.33333 2.99999C7.33333 2.07952 8.07952 1.33333 8.99999 1.33333C9.92047 1.33333 10.6667 2.07952 10.6667 2.99999ZM10.6667 8.99999C10.6667 9.92047 9.92047 10.6667 8.99999 10.6667C8.07952 10.6667 7.33333 9.92047 7.33333 8.99999C7.33333 8.07952 8.07952 7.33333 8.99999 7.33333C9.92047 7.33333 10.6667 8.07952 10.6667 8.99999ZM8.99999 16.6667C9.92047 16.6667 10.6667 15.9205 10.6667 15C10.6667 14.0795 9.92047 13.3333 8.99999 13.3333C8.07952 13.3333 7.33333 14.0795 7.33333 15C7.33333 15.9205 8.07952 16.6667 8.99999 16.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxIconThreeDotMenu);
export default __webpack_public_path__ + "static/media/mxIconThreeDotMenu.f5d5bc7cea76670d7976cfd63c70ac3b.svg";
export { ForwardRef as ReactComponent };